<micro-lookup domain="chat" obj="chatSenders" url="/chat/chatSenders" [key]="chatSenderId"></micro-lookup>
